import { apiRoutes } from "@constants/api-routes";
import { RESET_USER_PASSWORD_EMAIL_PATTERN } from "@constants/url-parameter-patterns";
import { RequestTypes } from "@enums/request-types";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequest } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";

type ResetAxnAdminUsersPasswordRequestResponse = {
    message: string;
};
export const resetAxnAdminUserPasswordRequest = async (axnAdminUserEmail: string): Promise<GenericNetworkResponse<ResetAxnAdminUsersPasswordRequestResponse>> => {
    const route = injectCustomIdParameter(
        apiRoutes.axnadminCore.resetUserPasswordWithEmail,
        axnAdminUserEmail,
        RESET_USER_PASSWORD_EMAIL_PATTERN
    );
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};